itsoftApp.createModule("test", function () {
    const testBlockEl = document.querySelector('#imt');

    if (!testBlockEl) {
        return;
    }
    
    const dots = testBlockEl.querySelector(".js-dots");
    const sliderNav = testBlockEl.querySelector(".js-slider-nav");

    let urlGlobal = null;
    // let currentFirstQuestionValue = null;
    const mainColorEl = testBlockEl.querySelector('.js-main-color');
    const prevBtnEl = testBlockEl.querySelector(".js-prev-btn");
    const nextBtnEl = testBlockEl.querySelector(".js-next-btn");
    const testToggleEls = testBlockEl.querySelectorAll(".js-test-toggle");
    const testInputEls = testBlockEl.querySelectorAll(".js-test-input");
    const testFormEl = testBlockEl.querySelector(".js-test-form");
    const testStepEls = testBlockEl.querySelectorAll(".js-step-block");
    // const colorLabelEls = testBlockEl.querySelectorAll(".js-pick-color");
    // const thirdStepEl = testBlockEl.querySelector(".js-step-3");
    const resultEl = testBlockEl.querySelector(".js-result");
    const conditionButtonEl = testBlockEl.querySelector(".js-condition");
    const submitButtonEl = testBlockEl.querySelector(".js-submit");
    const inputLabelEls = testBlockEl.querySelectorAll(".js-input-label");
    const sliderNavEl = testBlockEl.querySelector(".js-slider-nav");
    // const silhouetteEls = testBlockEl.querySelectorAll(".js-silhouette");
    // const resultSilhouetteWrapperEl = testBlockEl.querySelector(".js-silhouette-image-wrapper");
    // const resultImageWrapperEl = testBlockEl.querySelector(".js-result-image-wrapper");
    // const resultImageEl = testBlockEl.querySelector(".js-result-image");

    // const labelOver = function (evt) {
    //     const target = evt.currentTarget.control;
    //     const value = target.getAttribute("value");
    //     const silhouette = testBlockEl.querySelector('[data-value="' + value + '"]');
    //     silhouette.classList.add("js-hover");
    //     target.classList.add("js-hover");
    // }

    // const labelOut = function (evt) {
    //     const target = evt.currentTarget.control;
    //     const value = target.getAttribute("value");
    //     const silhouette = testBlockEl.querySelector('[data-value="' + value + '"]');
    //     silhouette.classList.remove("js-hover");
    //     target.classList.remove("js-hover");
    // }

    // const silhouetteOver = function (evt) {
    //     const target = evt.currentTarget;
    //     const value = target.getAttribute("data-value");
    //     const button = testBlockEl.querySelector('[value="' + value + '"] ~ .js-input-label');
    //     button.classList.add("js-hover");
    //     target.classList.add("js-hover");
    // }

    // const silhouetteOut = function (evt) {
    //     const target = evt.currentTarget;
    //     const value = target.getAttribute("data-value");
    //     const button = testBlockEl.querySelector('[value="' + value + '"] ~ .js-input-label');
    //     button.classList.remove("js-hover");
    //     target.classList.remove("js-hover");
    // }

    // const silhouetteClick = function (evt) {
    //     evt.preventDefault();
    //     const target = evt.currentTarget;
    //     const value = target.getAttribute("data-value");
    //     const button = testBlockEl.querySelector('[value="' + value + '"]');
    //     const selectedSilhouettes = testBlockEl.querySelectorAll('[data-value="' + value + '"]');

    //     Array.prototype.forEach.call(silhouetteEls, function (silhouette) {
    //         silhouette.classList.remove('js-active');
    //     })

    //     Array.prototype.forEach.call(selectedSilhouettes, function (silhouette) {
    //         silhouette.classList.add('js-active');
    //     })

    //     const currentColor = target.getAttribute("data-default-color");
    //     mainColorEl.setAttribute("data-main-color", currentColor);

    //     button.checked = true;
    // }

    const processResults = function (data) {
        const wrapper = document.createElement("div");
        wrapper.innerHTML = data;
        const resultData = wrapper.querySelector(".js-result");
        sliderNavEl.classList.add('js-z-index-less');
        dots.classList.add("js-hide");
        sliderNav.classList.add("js-hide");
        Swiper.initedSliders["test"].appendSlide(resultData);
        Swiper.initedSliders["test"].slideTo(Swiper.initedSliders["test"].slides.length - 1);
        // resultImageEl.src = resultData.getAttribute("data-image");

        const testResetEl = testBlockEl.querySelector(".js-test-reset");
        testResetEl.addEventListener("click", resetTest);
        // resultImageWrapperEl.classList.remove("js-hide");
        // resultSilhouetteWrapperEl.classList.add("js-hide");

        // resultEl.appendChild(resultData);
    };

    const resetTest = function (evt) {
        // const defaultInput = colorLabelEls[0].control;
        // const defaultInputValue = defaultInput.value;
        evt.preventDefault();
        // mainColorEl.setAttribute("data-main-color", defaultInput.getAttribute("data-color"));

        // resultImageWrapperEl.classList.add("js-hide");
        // resultSilhouetteWrapperEl.classList.remove("js-hide");
        // resultSilhouetteWrapperEl.classList.remove("js-disabled");

        // const selectedSilhouettes = testBlockEl.querySelectorAll('[data-value="' + defaultInputValue + '"]');

        // Array.prototype.forEach.call(silhouetteEls, function (silhouette) {
        //     silhouette.classList.remove('js-active');
        // });

        // Array.prototype.forEach.call(selectedSilhouettes, function (silhouette) {
        //     silhouette.classList.add('js-active');
        // });

        // currentFirstQuestionValue = null;
        // thirdStepEl.style.display = "";
        sliderNavEl.classList.remove('js-z-index-less');

        conditionButtonEl.classList.remove("js-hide");
        submitButtonEl.classList.add("js-hide");

        // if (!testBlockEl.querySelector(".js-step-3")) {
        //     Swiper.initedSliders["test"].addSlide(2, thirdStepEl);
        // }

        const actualTestToggleEls = testBlockEl.querySelectorAll(".js-test-toggle");

        Array.prototype.forEach.call(actualTestToggleEls, function (input) {
            input.checked = false;
        });

        Array.prototype.forEach.call(testInputEls, function (input) {
            input.value = "";
        });

        // defaultInput.checked = true;

        dots.classList.remove("js-hide");
        sliderNav.classList.remove("js-hide");

        // Swiper.initedSliders["test"].removeSlide(2);
        Swiper.initedSliders["test"].removeSlide(Swiper.initedSliders["test"].slides.length - 1);
        Swiper.initedSliders["test"].slideTo(0);

        const checkedToggles = Array.prototype.filter.call(actualTestToggleEls, item => item.checked);
        Swiper.initedSliders["test"].customCheckedToggles = checkedToggles;
        Swiper.initedSliders["test"].params.custom.checkedToggles = checkedToggles;

        if (Swiper.initedSliders["test"].params.custom.checkedToggles.length != Swiper.initedSliders["test"].params.custom.toggleSetEls.length) {
            console.log("reset, disabled")
            Swiper.initedSliders["test"].allowSlideNext = false;
            Swiper.initedSliders["test"].params.custom.nextBtn.disabled = true;
        } else {
            Swiper.initedSliders["test"].allowSlideNext = true;
            Swiper.initedSliders["test"].params.custom.nextBtn.disabled = false;
        }

        // const resultData = data.querySelector(".js-data");
        // resultEl.remove(resultData);

        // nextBtnEl.classList.remove('js-disabled');
    }

    const onErrorLoad = function (data) {
        console.log("error ", data);
    };

    const sendRequest = function (onSuccess, onError) {
        const xhr = new XMLHttpRequest();

        xhr.addEventListener("load", function () {
            if (xhr.status === 200 && onSuccess) {
                onSuccess(xhr.response);
            } else {
                onError(xhr.response);
            }
        });

        xhr.addEventListener("error", function () {
            onError("Произошла ошибка соединения");
        });
        xhr.addEventListener("timeout", function () {
            onError("Запрос не успел выполниться за " + xhr.timeout + "мс");
        });

        xhr.timeout = 10000;

        xhr.open("GET", urlGlobal);
        xhr.send();
    }

    const preResultActions = function (resultValue) {  
        let url = "?";
        let value = resultValue;

        // Array.prototype.forEach.call(allInputsValues, function (inputValue, index, arr) {
        //     value += inputValue.value[0];
        // });

        url += 'result' + "=" + value;

        url.replace(/\s/g, '+');

        const action = testFormEl.getAttribute("action");

        const query = action + url;

        // history.pushState("", "", url);
        urlGlobal = query;
        sendRequest(processResults, onErrorLoad, true);
    }

    const debouncer = itsoftApp.utils.debouncer(preResultActions, 500);

    var preciseValue = function (value) {
        return Math.round(value * 10) / 10;
    }

    const createRequest = function () {
        let allInputsValues = [];
        const actualTestStepEls = testBlockEl.querySelectorAll(".js-step-block");
        const weight = testBlockEl.querySelector(".js-weight");
        const height = testBlockEl.querySelector(".js-height");

        let resultValue = weight.value / ((height.value / 100) * (height.value / 100));

        // allInputsValues = Array.prototype.map.call(actualTestStepEls, function (stepBlock) {
        //     const allTestInputsEls = stepBlock.querySelectorAll(".js-test-toggle") || [];
        //     const allCheckedToggles = Array.prototype.filter.call(allTestInputsEls, item => item.checked) || [];
            
        //     return {
        //         name: stepBlock.getAttribute("name") || stepBlock.getAttribute("data-name") || allCheckedToggles[0].name,
        //         value: Array.prototype.map.call(allCheckedToggles, (checkedTestInput) => checkedTestInput.value)
        //     }
        // });

        resultValue = preciseValue(resultValue);

        debouncer(resultValue);
    }

    // const colorChange = function (target) {
    //     const currentColor = target.getAttribute("data-color");
    //     mainColorEl.setAttribute("data-main-color", currentColor);
    // }

    // const colorChangeSilhouette = function (target) {
    //     const value = target.getAttribute("value");
    //     const selectedSilhouettes = testBlockEl.querySelectorAll('[data-value="' + value + '"]');

    //     Array.prototype.forEach.call(silhouetteEls, function (silhouette) {
    //         silhouette.classList.remove('js-active');
    //     })

    //     Array.prototype.forEach.call(selectedSilhouettes, function (silhouette) {
    //         silhouette.classList.add('js-active');
    //         mainColorEl.setAttribute("data-main-color", target.getAttribute("data-color"));
    //     })
    // }

    // const onLabelClickRecordChoice = function (evt) {
    //     const target = evt.currentTarget;
    //     currentFirstQuestionValue = target.control.value;
    //     if (currentFirstQuestionValue == 1 || currentFirstQuestionValue == 4 || currentFirstQuestionValue == 5) {
    //         Swiper.initedSliders["test"].removeSlide(2);
    //     } else {
    //         Swiper.initedSliders["test"].addSlide(2, thirdStepEl);
    //     }
    //     colorChange(target);
    //     colorChangeSilhouette(target.control);
    // }

    const onInputChange = function (evt) {
        const activeItem = testStepEls[Swiper.initedSliders["test"].activeIndex];
        const activeInput = activeItem.querySelector(".js-test-input");

        if (activeInput.value) {
            Swiper.initedSliders["test"].allowSlideNext = true;
            Swiper.initedSliders["test"].params.custom.nextBtn.disabled = false;
        } else {
            Swiper.initedSliders["test"].allowSlideNext = false;
            Swiper.initedSliders["test"].params.custom.nextBtn.disabled = true;
        }

        if (Swiper.initedSliders["test"].params.custom.checkedToggles.length == Swiper.initedSliders["test"].params.custom.toggleSetEls.length && Swiper.initedSliders["test"].activeIndex + 1 == Swiper.initedSliders["test"].slides.length && ((activeInput && activeInput.value) || !activeInput)) {
            conditionButtonEl.classList.add("js-hide");
            submitButtonEl.classList.remove("js-hide");
        } else {
            conditionButtonEl.classList.remove("js-hide");
            submitButtonEl.classList.add("js-hide");
        }
    }

    const onToggleChange = function (evt) {
        let checkedToggles = [];
        const actualTestToggleEls = testBlockEl.querySelectorAll(".js-test-toggle");

        checkedToggles = Array.prototype.filter.call(actualTestToggleEls, item => item.checked);
        Swiper.initedSliders["test"].customCheckedToggles = checkedToggles;
        Swiper.initedSliders["test"].params.custom.checkedToggles = checkedToggles;

        if (Swiper.initedSliders["test"].params.custom.checkedToggles.length != Swiper.initedSliders["test"].params.custom.toggleSetEls.length) {
            Swiper.initedSliders["test"].allowSlideNext = false;
            Swiper.initedSliders["test"].params.custom.nextBtn.disabled = true;
        } else {
            Swiper.initedSliders["test"].allowSlideNext = true;
            Swiper.initedSliders["test"].params.custom.nextBtn.disabled = false;
        }

        if (Swiper.initedSliders["test"].params.custom.checkedToggles.length == Swiper.initedSliders["test"].params.custom.toggleSetEls.length && Swiper.initedSliders["test"].activeIndex + 1 == Swiper.initedSliders["test"].slides.length) {
            conditionButtonEl.classList.add("js-hide");
            submitButtonEl.classList.remove("js-hide");
        } else {
            conditionButtonEl.classList.remove("js-hide");
            submitButtonEl.classList.add("js-hide");
        }
    }

    const init = function () {
        // Array.prototype.forEach.call(colorLabelEls, function (label) {
        //     label.addEventListener("click", onLabelClickRecordChoice);
        //     label.addEventListener("mouseover", labelOver);
        //     label.addEventListener("mouseout", labelOut);
        // });

        Array.prototype.forEach.call(testToggleEls, function (input) {
            input.addEventListener("change", onToggleChange);
        });

        Array.prototype.forEach.call(testInputEls, function (input) {
            input.addEventListener("input", onInputChange);
        })

        submitButtonEl.addEventListener("click", createRequest);

        // Array.prototype.forEach.call(silhouetteEls, function (silhouette) {
        //     silhouette.addEventListener("mouseover", silhouetteOver);
        //     silhouette.addEventListener("mouseout", silhouetteOut);
        //     silhouette.addEventListener("click", silhouetteClick);
        // });
    }

    init();
});